import { useContext } from "react";
import MagnetContext from "./MagnetContext";

const useMagnets = () => {
    return useContext(MagnetContext);
}

export default useMagnets;